var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"panel",attrs:{"id":_vm.getTabPanelElementId(_vm.tabsId, _vm.activeTabId),"role":"tabpanel","tabindex":_vm.tabIndexAttr,"aria-labelledby":_vm.getTabElementId(_vm.tabsId, _vm.activeTabId)}},[_vm._t("default"),_vm._v(" "),_vm._t([_vm.activeTabId])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }